import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
// import {Auth} from "@/packages/auth";
import MerchantBeneficiaries from "@/packages/WaasModules/Beneficiary/component/MerchantBeneficiaries.vue";
import Beneficiary from "@/packages/WaasModules/Beneficiary/component/AmendBeneficiary.vue";
import WalletTopUp from "@/packages/WaasModules/Beneficiary/component/WalletTopUp.vue";
import SendToBeneficiary from "@/packages/WaasModules/Beneficiary/component/BeneficiarySendToBeneficiary.vue";
import BankTransfer from "@/packages/WaasModules/Beneficiary/component/BankTransfer.vue";
import SendToMerchant from "@/packages/WaasModules/Beneficiary/component/SendToMerchant.vue";

const BeneficiaryRoutes =[
    {
        path: '/dashboard/waas/beneficiaries',
        component: DashboardLayout,
        children: [
            {
                path: '',
                component: MerchantBeneficiaries,
                name: "BeneficiaryListing",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'amend-details',
                component: Beneficiary,
                name: "AmendBeneficiary",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'wallet/top-up',
                component: WalletTopUp,
                name: "WalletTopUp",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'wallet/send-to-beneficiary',
                component: SendToBeneficiary,
                name: "SendToBeneficiary",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'wallet/mobile-money-transfer',
                component: SendToBeneficiary,
                name: "MobileMoneyTransfer",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'wallet/send-to-bank',
                component: BankTransfer,
                name: "BankTransfer",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'wallet/send-to-bank',
                component: BankTransfer,
                name: "BankTransfer",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'wallet/send-to-merchant',
                component: SendToMerchant,
                name: "SendToMerchant",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default BeneficiaryRoutes;
